export default __webpack_public_path__ + "static/media/library-blue.5932ec7d.svg";